import { render, staticRenderFns } from "./businessHandling.vue?vue&type=template&id=b3817d3e&scoped=true"
import script from "./businessHandling.vue?vue&type=script&lang=js"
export * from "./businessHandling.vue?vue&type=script&lang=js"
import style0 from "./businessHandling.vue?vue&type=style&index=0&id=b3817d3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3817d3e",
  null
  
)

export default component.exports